
import { createSlice } from '@reduxjs/toolkit';

interface EventDataProps {
    event: any;
}

const initialState: EventDataProps = {
  event: false,
};

const addEventSlice = createSlice({
  name: 'downloadEvent',
  initialState,
  reducers: {
    setEvent(state, action) {
      state.event = action.payload;
    },
    resetEvent(state) {
      state.event = null;
    },
  },
});

export const { resetEvent, setEvent } = addEventSlice.actions;
export default addEventSlice.reducer;